import { HttpContextToken } from "@angular/common/http"
import { Context } from "@opentelemetry/api"

export const OTEL_PARENT_CONTEXT = new HttpContextToken<Context | undefined>(() => undefined)
